var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.14 28.04H4.74c-.7-.35-1.47-.56-2.05-1.13-1-1-1.75-2.2-2.47-3.39-.37-.61-.07-1.54.6-1.73.66-.2.76-.56.73-1.1 0-.18.05-.35.07-.52A18.45 18.45 0 0 1 15.56 4.18c.42-.1.6-.22.62-.7A3.36 3.36 0 0 1 19.03.12c2.57-.44 4.09 1.7 4.1 3.64 0 .35.26.33.48.39a18.45 18.45 0 0 1 14.14 16.63c.05.57.13.86.83.85 1.07-.02 1.74 1.14 1.16 2.02-1.19 1.81-2.21 3.84-4.6 4.4ZM19.66 21.6h15.58c1.2 0 1.2 0 1.08-1.17A16.8 16.8 0 0 0 16.56 5.44c-7.61 1.4-13.05 8-13.63 15.47-.04.53.08.7.64.7 5.36-.03 10.73-.02 16.1-.02ZM1.54 23.03c.47.69.9 1.25 1.27 1.84a3.65 3.65 0 0 0 3.36 1.76c8.75-.02 17.5-.01 26.25-.01 3.58 0 3.58 0 5.63-2.97.12-.18.36-.33.25-.62H1.54ZM19.64 3.7c.58.03 1.14.03 1.7.09.38.04.42-.1.38-.44a2.13 2.13 0 0 0-2.1-1.8c-1.03.03-1.98.9-2.05 1.89-.03.29.07.38.36.35.57-.05 1.15-.06 1.7-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 19.22c.32-1.74.93-3.45 1.83-5.06a15.03 15.03 0 0 1 4.95-5.34c.43-.29.88-.49 1.22.06.34.54-.02.86-.45 1.15-3.32 2.19-5.24 5.31-6.1 9.14-.04.12-.05.25-.08.38-.1.4-.35.66-.79.6-.46-.08-.62-.41-.58-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.95 6.57h.7c.44 0 .68.27.7.68 0 .42-.24.72-.67.73-1.06.02-2.1.15-3.13.36-.42.08-.73-.13-.8-.55-.09-.42.09-.73.5-.84.9-.23 1.82-.33 2.7-.38Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDish);
export default ForwardRef;